import { Link } from "react-router-dom";
import { Crown, Zap } from "lucide-react";

export const UsagePill = ({ usage }) => {
  if (!usage) return null;
  const premium = usage.plan === "premium";
  const out = usage.remaining === 0;
  return (
    <div className="flex items-center gap-2" data-testid="usage-indicator">
      <span data-testid="usage-remaining" className={`text-xs rounded-full border px-3 py-1.5 inline-flex items-center gap-1.5 ${out ? "border-rose-500/50 text-rose-400" : "border-border text-muted-foreground"}`}>
        {premium ? <Crown className="h-3.5 w-3.5 text-amber-400" /> : <Zap className="h-3.5 w-3.5" />}
        {usage.remaining} of {usage.limit} {premium ? "Premium" : "free"} replies left today
      </span>
      {!premium && (
        <Link to="/upgrade" data-testid="usage-upgrade-link" className="text-xs font-semibold rounded-full px-3 py-1.5 brand-gradient text-white hover:opacity-90">Upgrade</Link>
      )}
    </div>
  );
};

export const QuotaBlock = ({ message }) => (
  <div className="panel p-5 border-amber-500/40 space-y-3" data-testid="quota-exhausted">
    <p className="text-sm">{message}</p>
    <Link to="/upgrade" data-testid="quota-upgrade-button" className="inline-flex h-10 items-center gap-2 rounded-full px-5 text-sm font-semibold brand-gradient text-white">
      <Crown className="h-4 w-4" />Upgrade to Premium
    </Link>
  </div>
);
